import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ReceiveCartableListViewModel } from "../receiveCartableList/receiveCartableList-viewModel";
import  { ReceiveFormView } from "./receiveForm-view"

export class ReceiveFormViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ReceiveCartableListViewModel, sendPackageId) {
        super(parentViewModel);
        this.sendPackageId = sendPackageId;
        this.receiveFormItems = ObservableArray.create<ReceiveFormItem>();
    }
    closePopup(message?:string) {
    }
        GetDefaultView(): View <ViewModel> {
        return new ReceiveFormView();
    }
    public getTypeId(): string {
        return "VM-3495E46B-A2B7-436D-B941-5C4E347C8F24"
    }

    private _typedParent : ReceiveCartableListViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set receiveFormItems(v: ObservableArray<ReceiveFormItem>) { this._receiveFormItems = v; } public get receiveFormItems(): ObservableArray<ReceiveFormItem> { return this._receiveFormItems; } private _receiveFormItems: ObservableArray<ReceiveFormItem>;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set receiveTime(v: moment.Moment) { this._receiveTime = v; } public get receiveTime(): moment.Moment { return this._receiveTime;} private _receiveTime: moment.Moment;
    public set sentTime(v: moment.Moment) { this._sentTime = v; } public get sentTime(): moment.Moment { return this._sentTime;} private _sentTime: moment.Moment;
    public set sendNumber(v: string) { this._sendNumber = v; } public get sendNumber(): string { return this._sendNumber;} private _sendNumber: string;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState;} private _sendPackageState: number;
    public set canReceive(v: boolean) { this._canReceive = v; } public get canReceive(): boolean { return this._canReceive;} private _canReceive: boolean;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName;} private _driverName: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set sendPackageId(v: string) { 
        this._sendPackageId = v;
        this.load();
    } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ReceiveCartableDetail',{
                SendPackageId:this.sendPackageId
            });
            this.creationTime = moment.utc(result.CreatedTime);
            this.receiveTime = result.ReceiveTime==null ? null : moment.utc(result.ReceiveTime);
            this.sentTime = result.SentTime==null ? null : moment.utc(result.SentTime);
            this.amount = result.Amount;
            this.sendNumber = result.SendNumber;
            this.sendPackageState = result.SendPackageState;
            this.canReceive = this.sendPackageState === 1;
            this.toWarehouseId = result.ToWarehouseId;
            this.toWarehouseName = result.ToWarehouseName;
            this.fromWarehouseId = result.FromWarehouseId;
            this.fromWarehouseName = result.FromWarehouseName;
            this.carNumber = result.CarNumber;
            this.driverName = result.DriverName + '-' + this.carNumber;
            
            this.receiveFormItems.update(...result.SendPackageItems.map((q, i) => {
                let r = new ReceiveFormItem(this);
                r.rowNumber = i + 1;
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.productCarModel = q.ProductCarModel;
                r.amount = q.Amount;
                r.productUnit = q.ProductUnit;
                r.amount = q.Amount;
                r.orderAmount = q.OrderAmount;
                
                r.receiptAmount = r.orderAmount;
                r.receiptComment = q.ReceiptComment;
                r.orderComment = q.OrderComment;
                r.factorAmount = q.FactorAmount;
                r.requestAmount = q.RequestAmount;
                r.factorInfos.update(...q.FactorAmounts.map(z=>{
                    let r2 = new factorInfo(r);
                    r2.factorNo = z.FactorNo;
                    r2.factorAmount = z.FactorAmount;
                    return r2;
                }))
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    verifyReceiveForm():string[]{
        let result :string[] =[];
        if(!this.receiveFormItems.every(x=> {
            return x.isCountCorrect || !stringIsNullOrEmpty(x.receiptComment);
        })){
            result.push('برای کالاهایی که شمارششان صحیح نیست توضیحات بنویسید.')
        }
        if(!this.receiveFormItems.every(x=> {
            return x.orderAmount >= x.receiptAmount;
        })){
            result.push('تعداد دریافتی بیشتر از تعداد ارسالی ست.')
        }
        return result;
    }

    async receive(){
        try {
            let verificationResult = this.verifyReceiveForm();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان دریافت');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ReceiveSendPackage',{
                ReceiptAmounts:this.receiveFormItems.map(q => {return { 
                    ReceiptAmount: q.receiptAmount,
                    MeasuredProductId: q.measuredProductId,
                    ReceiptComment: q.receiptComment
                }}),
                SendPackageId:this.sendPackageId,
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('دریافت با موفقیت انجام شد.','عملیات موفق');
            this.closePopup("done");

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }   

    close(){
        this.closePopup('yes');
    }
    
}


export class ReceiveFormItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this._typedParent = parent;
        this.factorInfos = ObservableArray.create<factorInfo>();
    }

    private _typedParent: ViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment;} private _orderComment: string;
    public set orderAmount(v: number) { this._orderAmount = v; } public get orderAmount(): number { return this._orderAmount;} private _orderAmount: number;
    public set receiptAmount(v: number) { 
        this._receiptAmount = getAsNumber(v,true); 
        this.isCountCorrect = this._receiptAmount == this.orderAmount;
    } public get receiptAmount(): number { return this._receiptAmount;} private _receiptAmount: number;
    public set receiptComment(v: string) { this._receiptComment = v; } public get receiptComment(): string { return this._receiptComment;} private _receiptComment: string;
    public set isCountCorrect(v: boolean) { this._isCountCorrect = v; } public get isCountCorrect(): boolean { return this._isCountCorrect;} private _isCountCorrect: boolean;
    public set factorAmount(v: number) { this._factorAmount = v; } public get factorAmount(): number { return this._factorAmount;} private _factorAmount: number;
    public set requestAmount(v: number) { this._requestAmount = v; } public get requestAmount(): number { return this._requestAmount;} private _requestAmount: number;
    public set factorInfos(v: ObservableArray<factorInfo>) { this._factorInfos = v; } public get factorInfos(): ObservableArray<factorInfo> { return this._factorInfos;} private _factorInfos: ObservableArray<factorInfo>;
    
    async onePlus(){
        this.receiptAmount++;
    }

}

export class factorInfo extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo;} private _factorNo: string;
    public set factorAmount(v: number) { this._factorAmount = v; } public get factorAmount(): number { return this._factorAmount;} private _factorAmount: number;
}